// ===================================================================
// KAIXO - MinutePacks API client
// ===================================================================
// Cliente axios para /api/billing/minutes/*. Aislado del resto.
// ===================================================================

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend-dlmm.onrender.com/api';

const api = axios.create({
    baseURL: `${API_URL}/billing/minutes`,
    withCredentials: false
});

api.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem('kaixo_token');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        const userStr = localStorage.getItem('kaixo_user');
        if (userStr) {
            const u = JSON.parse(userStr);
            if (u?._id) config.headers['x-user-id'] = u._id;
        }
    } catch {}
    return config;
});

export const listPacks   = () => api.get('/packs');
export const getBalance  = () => api.get('/balance');
export const createCheckout = ({ sku, successUrl, cancelUrl }) =>
    api.post('/checkout', { sku, successUrl, cancelUrl });
